<div class="admin-access-actions" dir="{{languageDir}}" *ngIf="statusLoaded">
  <!-- Actionable rows only — show Approve / Reject when the request is still awaiting a response. -->
  <ng-container *ngIf="isPending; else statusPill">
    <button type="button"
            class="admin-access-actions__btn admin-access-actions__btn--approve"
            (click)="onApprove($event)">
      <mat-icon>how_to_reg</mat-icon>
      <span>{{ langObj?.Approve ?? ('Approve' | translate) }}</span>
    </button>
    <button type="button"
            class="admin-access-actions__btn admin-access-actions__btn--reject"
            (click)="onReject($event)">
      <mat-icon>clear</mat-icon>
      <span>{{ langObj?.Reject ?? ('Reject' | translate) }}</span>
    </button>
  </ng-container>

  <!-- Terminal states (Approved / Rejected / Expired) — render as a colored pill instead of buttons. -->
  <ng-template #statusPill>
    <span *ngIf="status" class="admin-access-actions__status admin-access-actions__status--{{ status | lowercase }}">
      {{ langObj?.[statusLabelKey] ?? (statusLabelKey | translate) }}
    </span>
  </ng-template>
</div>
